import React, { useEffect, useState, useRef } from 'react';
export function Fanspace() {
  const [isOpen, setIsOpen] = useState(false);
  const defaultAvatar = 'https://archives.bulbagarden.net/media/upload/b/b3/Pok%C3%A9_Ball_ZA_Art.png';
  const [username, setUsername] = useState('');
  const [avatar, setAvatar] = useState(defaultAvatar);
  const [avatarPreview, setAvatarPreview] = useState('');
  const [message, setMessage] = useState('');
  const [isSetup, setIsSetup] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);
  // Track liked messages by the current user
  const [likedMessages, setLikedMessages] = useState(new Set());
  const [equippedSticker, setEquippedSticker] = useState(null);
  const [messages, setMessages] = useState([{
    id: 1,
    username: 'AshKetchum',
    avatar: 'https://archives.bulbagarden.net/media/upload/b/b3/Pok%C3%A9_Ball_ZA_Art.png',
    text: "Welcome to the Pokémon Fanspace chat! Let's talk about our favorite Pokémon!",
    timestamp: new Date().toLocaleTimeString(),
    likes: 0,
    replies: [],
    sticker: '🔥'
  }]);
  const chatContainerRef = useRef(null);
  const fileInputRef = useRef(null);
  useEffect(() => {
    // Scroll to bottom of chat when new messages are added
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
    // Load equipped sticker
    const storedEquippedSticker = localStorage.getItem('equippedSticker');
    if (storedEquippedSticker) {
      const stickerId = storedEquippedSticker;
      const stickers = {
        fire: '🔥',
        water: '💧',
        wave: '🌊',
        earth: '🌍',
        camping: '🏕️',
        desert: '🏜️',
        national_park: '🏞️',
        island: '🏝️',
        mountain: '🏔️'
      };
      if (stickerId && stickers[stickerId]) {
        setEquippedSticker(stickers[stickerId]);
      }
    }
  }, [messages]);
  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is an image
      if (!file.type.match('image.*')) {
        alert('Please select an image file');
        return;
      }
      // Check file size (limit to 2MB)
      if (file.size > 2 * 1024 * 1024) {
        alert('Image size should be less than 2MB');
        return;
      }
      const reader = new FileReader();
      reader.onload = e => {
        setAvatarPreview(e.target.result);
        setAvatar(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  const filterProfanity = text => {
    const profanityList = ['fuck', 'ass', 'bitch', 'dick', 'nigger', 'cunt'];
    let filteredText = text;
    profanityList.forEach(word => {
      const regex = new RegExp(`\\b${word}\\b`, 'gi');
      filteredText = filteredText.replace(regex, '***');
    });
    return filteredText;
  };
  // Simulate other users liking a message
  const simulateOtherUserLike = messageId => {
    // Update like count (increment)
    setMessages(messages.map(msg => {
      if (msg.id === messageId) {
        return {
          ...msg,
          likes: msg.likes + 1
        };
      } else if (msg.replies && msg.replies.length > 0) {
        const updatedReplies = msg.replies.map(reply => {
          if (reply.id === messageId) {
            return {
              ...reply,
              likes: reply.likes + 1
            };
          }
          return reply;
        });
        return {
          ...msg,
          replies: updatedReplies
        };
      }
      return msg;
    }));
  };
  const handleLike = messageId => {
    // Toggle like status
    const newLikedMessages = new Set(likedMessages);
    if (likedMessages.has(messageId)) {
      // User is unliking the message
      newLikedMessages.delete(messageId);
      // Decrement like count
      setMessages(messages.map(msg => {
        if (msg.id === messageId) {
          return {
            ...msg,
            likes: Math.max(0, msg.likes - 1) // Ensure likes don't go below 0
          };
        } else if (msg.replies && msg.replies.length > 0) {
          const updatedReplies = msg.replies.map(reply => {
            if (reply.id === messageId) {
              return {
                ...reply,
                likes: Math.max(0, reply.likes - 1) // Ensure likes don't go below 0
              };
            }
            return reply;
          });
          return {
            ...msg,
            replies: updatedReplies
          };
        }
        return msg;
      }));
    } else {
      // User is liking the message
      newLikedMessages.add(messageId);
      // Increment like count
      setMessages(messages.map(msg => {
        if (msg.id === messageId) {
          return {
            ...msg,
            likes: msg.likes + 1
          };
        } else if (msg.replies && msg.replies.length > 0) {
          const updatedReplies = msg.replies.map(reply => {
            if (reply.id === messageId) {
              return {
                ...reply,
                likes: reply.likes + 1
              };
            }
            return reply;
          });
          return {
            ...msg,
            replies: updatedReplies
          };
        }
        return msg;
      }));
      // Randomly simulate other users liking this message too
      // There's a 40% chance another user will like it shortly after
      if (Math.random() < 0.4) {
        setTimeout(() => {
          simulateOtherUserLike(messageId);
        }, 1000 + Math.random() * 2000); // Random delay between 1-3 seconds
      }
    }
    setLikedMessages(newLikedMessages);
  };
  const startReply = messageId => {
    setReplyingTo(messageId);
    // Focus on the message input
    setTimeout(() => {
      document.getElementById('messageInput')?.focus();
    }, 0);
  };
  const cancelReply = () => {
    setReplyingTo(null);
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!isSetup) {
      if (username.trim()) {
        setIsSetup(true);
      }
      return;
    }
    if (message.trim()) {
      const words = message.trim().split(/\s+/);
      if (words.length > 20) {
        alert('Messages are limited to 20 words. Please shorten your message.');
        return;
      }
      const filteredMessage = filterProfanity(message);
      const newMessage = {
        id: Date.now(),
        username,
        avatar,
        text: filteredMessage,
        timestamp: new Date().toLocaleTimeString(),
        likes: 0,
        replies: [],
        sticker: equippedSticker,
        // Store the username of the person being replied to
        replyingToUsername: replyingTo ? getReplyingToUsername() : null
      };
      // If replying to a message
      if (replyingTo) {
        setMessages(messages.map(msg => {
          if (msg.id === replyingTo) {
            return {
              ...msg,
              replies: [...msg.replies, newMessage]
            };
          } else if (msg.replies && msg.replies.some(reply => reply.id === replyingTo)) {
            // If replying to a reply, add it to the parent message's replies
            return msg;
          }
          return msg;
        }));
        setReplyingTo(null);
      } else {
        // Regular message
        setMessages([...messages, newMessage]);
      }
      setMessage('');
    }
  };
  // Helper function to get the username of the message being replied to
  const getReplyingToUsername = () => {
    const replyMessage = messages.find(msg => msg.id === replyingTo);
    if (replyMessage) return replyMessage.username;
    // Check if replying to a reply
    for (const msg of messages) {
      const reply = msg.replies.find(r => r.id === replyingTo);
      if (reply) return reply.username;
    }
    return '';
  };
  // Helper function to check if a message has been liked by the current user
  const isMessageLiked = messageId => {
    return likedMessages.has(messageId);
  };
  return <section className="bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-700 shadow-lg" data-id="element-46">
      <button className="w-full flex items-center justify-between bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-47">
        <span className="text-xl" data-id="element-48">Fanspace (Community Chat)</span>
        <svg className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-49">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-50"></path>
        </svg>
      </button>
      {isOpen && <div className="space-y-4 mt-4" data-id="element-51">
          <div className="bg-slate-700/60 rounded-lg p-4 mb-4" data-id="element-52">
            <p className="text-yellow-200 font-medium" data-id="element-53">
              Reminder: This chat is for Pokémon-related topics only. Off-topic
              discussions will be removed.
            </p>
          </div>
          {!isSetup ? <div className="bg-slate-700/60 rounded-lg p-4" data-id="element-54">
              <h3 className="text-xl font-semibold mb-3 text-blue-300" data-id="element-55">
                Create Your Profile
              </h3>
              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-56">
                <div data-id="element-57">
                  <label className="block text-gray-300 mb-1" data-id="element-58">Username</label>
                  <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full bg-slate-600 text-white px-3 py-2 rounded-md border border-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter a username" minLength={3} maxLength={15} required data-id="element-59" />
                  <p className="text-xs text-gray-400 mt-1" data-id="element-60">
                    Username must be between 3-15 characters.
                  </p>
                </div>
                <div data-id="element-61">
                  <label className="block text-gray-300 mb-1" data-id="element-62">
                    Upload Avatar Image
                  </label>
                  <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*" className="hidden" data-id="element-63" />
                  <div className="flex items-center space-x-4" data-id="element-64">
                    <div className="w-24 h-24 bg-slate-600 rounded-full flex items-center justify-center overflow-hidden border-2 border-slate-500" data-id="element-65">
                      {avatarPreview ? <img src={avatarPreview} alt="Avatar preview" className="w-full h-full object-cover" data-id="element-66" /> : <img src={defaultAvatar} alt="Default Poké Ball avatar" className="w-full h-full object-cover" data-id="element-67" />}
                    </div>
                    <button type="button" onClick={triggerFileInput} className="bg-slate-600 hover:bg-slate-500 text-white font-medium py-2 px-4 rounded-md transition-colors" data-id="element-68">
                      Choose Different Image
                    </button>
                  </div>
                  <p className="text-xs text-gray-400 mt-1" data-id="element-69">
                    Max file size: 2MB. Recommended: square image.
                  </p>
                </div>
                <button type="submit" disabled={!username.trim()} className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors disabled:bg-gray-500 disabled:cursor-not-allowed" data-id="element-70">
                  Join Chat
                </button>
              </form>
            </div> : <div data-id="element-71">
              <div ref={chatContainerRef} className="bg-slate-700/60 rounded-lg p-4 h-80 overflow-y-auto mb-4" data-id="element-72">
                {messages.map(msg => <div key={msg.id} className="mb-4" data-id="element-73">
                    <div className={`flex ${msg.username === username ? 'justify-end' : 'justify-start'}`} data-id="element-74">
                      <div className={`flex max-w-[80%] ${msg.username === username ? 'flex-row-reverse' : 'flex-row'}`} data-id="element-75">
                        <div className="flex flex-col items-center" data-id="element-76">
                          <img src={msg.avatar} alt={`${msg.username}'s avatar`} className="w-10 h-10 rounded-full flex-shrink-0 object-cover" data-id="element-77" />
                          {msg.username === 'TechInferno' && <div className="text-center mt-1" data-id="element-78">👑</div>}
                          {msg.sticker && <div className="text-center mt-1" data-id="element-79">
                              {msg.sticker}
                            </div>}
                        </div>
                        <div className={`mx-2 ${msg.username === username ? 'bg-blue-600' : 'bg-slate-600'} rounded-lg p-3`} data-id="element-80">
                          <div className="flex justify-between items-center mb-1" data-id="element-81">
                            <span className="font-semibold text-sm" data-id="element-82">
                              {msg.username}
                            </span>
                            <span className="text-xs text-gray-300" data-id="element-83">
                              {msg.timestamp}
                            </span>
                          </div>
                          {msg.replyingToUsername && <p className="text-xs italic text-blue-300 mb-1" data-id="element-84">
                              Replying to {msg.replyingToUsername}
                            </p>}
                          <p className="text-white" data-id="element-85">{msg.text}</p>
                          <div className="flex justify-between items-center mt-2" data-id="element-86">
                            <div className="flex items-center space-x-2" data-id="element-87">
                              <button onClick={() => handleLike(msg.id)} className={`${isMessageLiked(msg.id) ? 'text-yellow-300 hover:text-gray-300' : 'text-gray-300 hover:text-yellow-300'} transition-colors cursor-pointer`} title={isMessageLiked(msg.id) ? 'Unlike this message' : 'Like this message'} data-id="element-88">
                                👍 <span className="text-xs" data-id="element-89">{msg.likes}</span>
                              </button>
                              <button onClick={() => startReply(msg.id)} className="text-gray-300 hover:text-blue-300 transition-colors text-xs" data-id="element-90">
                                Reply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Replies */}
                    {msg.replies && msg.replies.length > 0 && <div className={`ml-12 mt-2 space-y-2 ${msg.username === username ? 'mr-12' : 'ml-12'}`} data-id="element-91">
                        {msg.replies.map(reply => <div key={reply.id} className={`flex ${reply.username === username ? 'justify-end' : 'justify-start'}`} data-id="element-92">
                            <div className={`flex max-w-[80%] ${reply.username === username ? 'flex-row-reverse' : 'flex-row'}`} data-id="element-93">
                              <div className="flex flex-col items-center" data-id="element-94">
                                <img src={reply.avatar} alt={`${reply.username}'s avatar`} className="w-8 h-8 rounded-full flex-shrink-0 object-cover" data-id="element-95" />
                                {reply.username === 'TechInferno' && <div className="text-center mt-1" data-id="element-96">👑</div>}
                                {reply.sticker && <div className="text-center mt-1" data-id="element-97">
                                    {reply.sticker}
                                  </div>}
                              </div>
                              <div className={`mx-2 ${reply.username === username ? 'bg-blue-700' : 'bg-slate-700'} rounded-lg p-2`} data-id="element-98">
                                <div className="flex justify-between items-center mb-1" data-id="element-99">
                                  <span className="font-semibold text-xs" data-id="element-100">
                                    {reply.username}
                                  </span>
                                  <span className="text-xs text-gray-300" data-id="element-101">
                                    {reply.timestamp}
                                  </span>
                                </div>
                                {reply.replyingToUsername && <p className="text-xs italic text-blue-300 mb-1" data-id="element-102">
                                    Replying to {reply.replyingToUsername}
                                  </p>}
                                <p className="text-white text-sm" data-id="element-103">
                                  {reply.text}
                                </p>
                                <div className="flex items-center mt-1" data-id="element-104">
                                  <button onClick={() => handleLike(reply.id)} className={`${isMessageLiked(reply.id) ? 'text-yellow-300 hover:text-gray-300' : 'text-gray-300 hover:text-yellow-300'} transition-colors cursor-pointer`} title={isMessageLiked(reply.id) ? 'Unlike this reply' : 'Like this reply'} data-id="element-105">
                                    👍{' '}
                                    <span className="text-xs" data-id="element-106">
                                      {reply.likes}
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>)}
                      </div>}
                  </div>)}
              </div>
              <form onSubmit={handleSubmit} className="space-y-2" data-id="element-107">
                {replyingTo && <div className="bg-slate-600/60 rounded-lg p-2 flex justify-between items-center" data-id="element-108">
                    <span className="text-sm text-blue-300" data-id="element-109">
                      Replying to {getReplyingToUsername()}
                    </span>
                    <button type="button" onClick={cancelReply} className="text-gray-300 hover:text-red-400 text-xs" data-id="element-110">
                      Cancel
                    </button>
                  </div>}
                <div className="flex" data-id="element-111">
                  <input id="messageInput" type="text" value={message} onChange={e => setMessage(e.target.value)} className="flex-grow bg-slate-600 text-white px-3 py-2 rounded-l-md border border-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder={replyingTo ? 'Type your reply (max 20 words)' : 'Type a message (max 20 words)'} maxLength={200} data-id="element-112" />
                  <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-r-md transition-colors" data-id="element-113">
                    Send
                  </button>
                </div>
              </form>
            </div>}
        </div>}
    </section>;
}